import type { AxiosInstance } from 'axios';

export type TNotificationStatus = {
  alertRuleId: string;
  shown: boolean;
};

export class AlertRulesNotificationsApi {
  baseUrl = '/notifications/api/v1/notification-preferences';

  private readonly agent: AxiosInstance;

  constructor(agent: AxiosInstance) {
    this.agent = agent;
  }

  fetchNotifications(alertRuleIds: string[], signal?: AbortSignal): Promise<TNotificationStatus[]> {
    return this.agent
      .post<{
        statuses: TNotificationStatus[];
      }>(this.baseUrl + '/status', { alertRuleIds }, { signal })
      .then((res) => res.data.statuses);
  }

  setAlertRuleNotificationsOption(alertRuleId: string, shown: boolean, signal?: AbortSignal): Promise<void> {
    return this.agent
      .put<void>(
        this.baseUrl + `/${alertRuleId}`,
        {
          shown,
        },
        { signal },
      )
      .then((res) => res.data);
  }
}
